var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIconWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.057v1.007H7.385v-1.007H15zM11.37 1.5c1.5 0 2.716 1.216 2.716 2.716 0 .65-.23 1.265-.641 1.752l-.029.03-9.075 9.06H.5v-3.843l.146-.147L9.62 2.142c.487-.412 1.102-.642 1.751-.642zM8.641 4.522l-7.14 7.108v2.427h2.426l7.131-7.119-2.417-2.416zm2.73-2.022c-.411 0-.798.145-1.076.378l-.945.94 2.416 2.414.928-.925c.252-.306.392-.687.392-1.09 0-.948-.768-1.717-1.716-1.717z"
  })));
}
export default SvgReviewIconWrite;